<template>
  <div>
    <el-form :model="modifyForm" ref="modifyForm" label-width="100px">
      <el-row>
        <el-col>
          <el-form-item label="不合格原因" prop="causeOfNonconformity">
            <ic-select v-model="modifyForm.causeOfNonconformity" table="TT_QSPI_QIP" field="CAUSE_OF_NONCONFORMITY"
              clearable placeholder="请选择" style="width:100%"></ic-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="风险等级" prop="riskGrade">
            <ic-select clearable table="TT_QSPI_QIP" field="RISK_GRADE" placeholder="请选择" v-model="modifyForm.riskGrade"
              style="width:100%"></ic-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="处理方式" prop="processingMode">
            <ic-select clearable table="TT_QSPI_QIP" field="PROCESSING_MODE" placeholder="请选择"
              v-model="modifyForm.processingMode" style="width:100%"></ic-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="责任方" prop="responsibleParty">
            <ic-select clearable table="TT_QSPI_QIP" field="RESPONSIBLE_PARTY" placeholder="请选择"
              v-model="modifyForm.responsibleParty" style="width:100%"></ic-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="责任方是否已确认" prop="responsibleConfirm">
            <ic-select clearable table="TT_QSPI_QIP" field="RESPONSIBLE_CONFIRM" placeholder="请选择"
              v-model="modifyForm.responsibleConfirm" style="width:100%"></ic-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="QIP_Owner备注" prop="ownerRemarks">
            <el-input v-model="modifyForm.ownerRemarks" type="textarea" maxlength="1000" show-word-limit
              :autosize="{ minRows: 4, maxRows: 6 }" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row type="flex" justify="center" style="margin-top:10px">
      <el-button size="small" type="primary" @click="onSave">保存</el-button>
      <el-button size="small" type="primary" @click="onCancel">取消</el-button>
    </el-row>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import QIPApi from "@/api/QIP/index";
export default {
  props: ['idList'],
  components: {
    IcSelect,
  },
  data() {
    return {
      modifyForm: {
        riskGrade: "",
        processingMode: "",
        responsibleParty: "",
        ownerRemarks: "",
        changeField: []
      },
    }
  },
  watch: {
    idList: {
      handler(newV, oldV) {
        console.log('newV', newV);
      },
      immediate: true
    }
  },
  methods: {
    onSave() {
      this.$set(this.modifyForm, 'idList', this.idList)
      if (this.modifyForm.causeOfNonconformity) {
        this.modifyForm.changeField.push('causeOfNonconformity')
      }
      if (this.modifyForm.processingMode) {
        this.modifyForm.changeField.push('processingMode')
      }
      if (this.modifyForm.responsibleParty) {
        this.modifyForm.changeField.push('responsibleParty')
      }
      if (this.modifyForm.ownerRemarks) {
        this.modifyForm.changeField.push('ownerRemarks')
      }
      if (this.modifyForm.riskGrade) {
        this.modifyForm.changeField.push('riskGrade')
      }
      if (this.modifyForm.responsibleConfirm) {
        this.modifyForm.changeField.push('responsibleConfirm')
      }
      console.log('this.modifyForm.', this.modifyForm);
      QIPApi.updateBatchQip(this.modifyForm).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('保存成功')
          this.onCancel()
        }
      })
    },
    onCancel() {
      this.modifyForm = {
        riskGrade: "",
        processingMode: "",
        responsibleParty: "",
        ownerRemarks: "",
        changeField: []
      }
      this.$emit('onClose')
    },
  }
}
</script>

<style></style>
